import styled, { css } from "styled-components";
import { Theme } from "../Theme";

export const Column = styled.div`
    display: ${(props) => props.display || "flex"};
    flex-direction: column;
    align-items: ${(props) => props.alignItem || "center"};
    justify-content: ${(props) => props.justifyContent || "flex-start"};
    padding: ${(props) => props.padding || "0px"};
    cursor: ${(props) => props.cursor || "inherit"};
    width: ${(props) => props.width || "auto"};
    height: ${(props) => props.height || "auto"};
    box-sizing: ${(props) => props.boxSizing || "border-box"};
    flex: ${(props) => props.flex || "none"};
    max-width: ${(props) => props.maxWidth || "100%"};
    min-width: ${(props) => props.minWidth || "0px"};
    gap: ${(props) => props.gap || "0px"};
    overflow: ${(props) => props.overflow || "hidden"};
    overflow-y: ${(props) => props.overflowY || "auto"};
`;

export const Row = styled.div`
    display: ${(props) => props.display || "flex"};
    flex-direction: row;
    align-items: ${(props) => props.alignItem || "center"};
    justify-content: ${(props) => props.justifyContent || "flex-start"};
    padding: ${(props) => props.padding || "0px"};
    cursor: ${(props) => props.cursor || "inherit"};
    width: ${(props) => props.width || "auto"};
    height: ${(props) => props.height || "auto"};
    box-sizing: ${(props) => props.boxSizing || "border-box"};
    flex: ${(props) => props.flex || "none"};
    max-width: ${(props) => props.maxWidth || "100%"};
    min-width: ${(props) => props.minWidth || "0px"};
    gap: ${(props) => props.gap || "0px"};
    border-top: ${({ $borderTop }) => ($borderTop ? `1px solid ${Theme.color.gray200}` : "none")};
    border-bottom: ${({ $borderBottom }) => ($borderBottom ? `1px solid ${Theme.color.gray200}` : "none")};
    overflow-x: ${(props) => props.overflowX || "visible"};
`;

export const Padding = styled.div`
    padding: ${(props) => props.padding || "0px"};
    box-sizing: ${(props) => props.boxSizing || "border-box"};
    overflow-x: visible;
`;

export const SizedBox = styled.div`
    width: ${(props) => props.width || "1px"};
    height: ${(props) => props.height || "1px"};
    border: ${(props) => props.border};
    border-bottom: ${(props) => props.borderBottom};
    border-radius: ${(props) => props.borderRadius || "0px"};
    border-top-left-radius: ${(props) => props.borderTopLeftRadius};
    border-top-right-radius: ${(props) => props.borderTopRightRadius};
    border-bottom-left-radius: ${(props) => props.borderBottomLeftRadius};
    border-bottom-right-radius: ${(props) => props.borderBottomRightRadius};
    background-color: ${(props) => props.backgroundColor || "transparent"};
    box-shadow: ${(props) => props.boxShadow || "none"};
    padding: ${(props) => props.padding || "0"};
    cursor: ${(props) => props.cursor || "inherit"};
    display: inline-flex;
    flex-direction: column;
    flex: ${(props) => props.flex || "none"};
    align-items: ${(props) => props.alignItem || "center"};
    justify-content: ${(props) => props.justifyContent || "center"};
    box-sizing: ${(props) => props.boxSizing || "border-box"};
    max-width: ${(props) => props.maxWidth || "100%"};
    min-width: ${(props) => props.minWidth || "0px"};
    min-height: ${(props) => props.minHeight || "0px"};
    overflow: ${(props) => props.overflow || "hidden"};
    &:hover {
        background-color: ${(props) => props.hoverBackgroundColor || props.backgroundColor || "transparent"};
        color: ${(props) => props.hoverColor || undefined};
    }
`;

export const Container = styled.div`
    padding: ${(props) => props.padding || "0px"};
    border-radius: ${(props) => props.borderRadius || "0px"};
    border: ${(props) => props.border};
    background-color: ${(props) => props.backgroundColor || "transparent"};
    display: inline-flex;
    align-items: ${(props) => props.alignItem || "center"};
    justify-content: ${(props) => props.justifyContent || "center"};
    cursor: ${(props) => props.cursor || "inherit"};
    max-height: ${(props) => props.maxHeight || "100%"};
    width: ${(props) => props.width || "auto"};
    min-height: ${(props) => props.minHeight || "0px"};
    &:hover {
        background-color: ${(props) => props.hoverBackgroundColor || props.backgroundColor || "transparent"};
    }
`;

export const Divider = styled.div`
    margin-left: ${(props) => props.marginLeft || "0px"};
    margin-right: ${(props) => props.marginRight || "0px"};
    margin-top: ${(props) => props.marginTop || "0px"};
    margin-bottom: ${(props) => props.marginBottom || "0px"};

    ${(props) => {
        const orientation = props.orientation || "horizontal";
        const lineStyle = props.lineStyle || "solid";
        const color = props.color || Theme.color.neutral200;
        const thickness = props.thickness || "1px";

        if (lineStyle === "solid") {
            return `
                background-color: ${color};
                width: ${props.width || (orientation === "vertical" ? thickness : "100%")};
                height: ${props.height || (orientation === "vertical" ? props.height || "100%" : thickness)};
            `;
        } else if (lineStyle === "custom-dotted") {
            const dotSize = props.$dotSize || "6px"; // 점 하나의 크기
            const gapSize = props.$gapSize || "2px"; // 점 사이 간격

            if (orientation === "vertical") {
                return `
                    width: ${thickness};
                    height: ${props.height || "100%"};
                    background: transparent;
                    border-left: ${thickness} solid transparent;
                    border-image: repeating-linear-gradient(
                        to bottom, 
                        ${color} 0, 
                        ${color} ${dotSize}, 
                        transparent ${dotSize}, 
                        transparent calc(${dotSize} + ${gapSize})
                    ) 1;
                `;
            } else {
                return `
                    height: ${thickness};
                    width: ${props.width || "100%"};
                    background: transparent;
                    border-top: ${thickness} solid transparent;
                    border-image: repeating-linear-gradient(
                        to right, 
                        ${color} 0, 
                        ${color} ${dotSize}, 
                        transparent ${dotSize}, 
                        transparent calc(${dotSize} + ${gapSize})
                    ) 1;
                `;
            }
        } else {
            const borderStyle = `${thickness} ${lineStyle} ${color}`;

            if (orientation === "vertical") {
                return `
                    background-color: transparent;
                    border-left: ${borderStyle};
                    width: 0px; 
                    height: ${props.height || "100%"}; 
                `;
            } else {
                return `
                    background-color: transparent;
                    border-top: ${borderStyle};
                    height: 0px; 
                    width: ${props.width || "100%"};
                `;
            }
        }
    }}
`;

export const BaseButton = styled.button`
    width: ${(props) => props.width || "auto"};
    height: ${(props) => props.height || "auto"};
    padding: ${(props) => props.padding || "0px"};
    border: ${(props) => props.border || `1px solid ${Theme.color.gray250}`};
    border-radius: ${(props) => props.borderRadius || "8px"};
    background-color: ${(props) => props.backgroundColor || Theme.color.white};
    border: ${(props) => props.border};
    color: ${(props) => props.fontColor || Theme.color.zinc850};
    font-size: ${(props) => props.fontSize || Theme.text.c4?.fontSize};
    font-weight: ${(props) => props.fontWeight || "500"};
    display: ${(props) => props.display || "flex"};
    align-items: center;
    justify-content: center;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    &:hover {
        background-color: ${(props) => props.hoverBackgroundColor || props.backgroundColor || Theme.color.white};
    }
`;

export const SingleScrollView = styled.div`
    /* --- 공통 속성 --- */
    width: 100%;
    box-sizing: border-box;

    /* --- 조건부 속성 (가변값) --- */
    height: ${({ $height }) => $height || "auto"};
    min-height: ${({ $minHeight }) => $minHeight || "0"};
    flex: ${({ $flex }) => $flex || "none"};
    gap: ${({ $gap }) => ($gap ? `${$gap}px` : "0")};
    cursor: ${({ $cursor }) => $cursor || "default"};

    /* --- 스크롤 제어 --- */
    overflow-y: ${({ $overflowY }) => $overflowY || "visible"};
    overflow-x: ${({ $overflowX }) => $overflowX || "visible"};

    /* --- Grid 레이아웃 적용 조건 --- */
    ${({ $gridTemplateColumns }) =>
        $gridTemplateColumns &&
        css`
            display: grid;
            grid-template-columns: ${$gridTemplateColumns};
        `}
`;
